(() => {
  "use strict";
  
  const SELECTOR_SLIDER_LOGOS = "[data-slider-logos]";
  const SELECTOR_SLIDER_TEXT = "[data-slider-text]";
  const SELECTOR_SLIDE = "[data-slide]";
  const CLASS_IS_SELECTED = "is-selected";
  const CLASS_IS_INITIALIZED = "is-initialized";
  const CLASS_FLICKITY_ENABLED = "flickity-enabled";
  const ATTR_DATA_SLIDE = "data-slide";
  const ATTR_DATA_SLIDE_INDEX = "data-slide-index";

  if (!customElements.get("logos-component")) {
    customElements.define("logos-component", class extends HTMLElement {
      constructor() {
        super();
        this.slideshowNav = this.querySelector(SELECTOR_SLIDER_LOGOS);
        this.slideshowText = this.querySelector(SELECTOR_SLIDER_TEXT);
        this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState();
        this.flkty = null;
        this.flktyNav = null;
        this.logoSlides = this.slideshowNav?.querySelectorAll(SELECTOR_SLIDE);
        this.logoSlidesWidth = this.getSlidesWidth();
        this.bindEvents();
      }

      connectedCallback() {
        this.initSlideshowText();
        this.initSlideshowNav();
      }

      getSlidesWidth() {
        return 200 * this.logoSlides?.length || 0;
      }

      initSlideshowText() {
        if (this.slideshowText) {
          this.flkty = new window.theme.FlickityFade(this.slideshowText, {
            fade: true,
            autoPlay: false,
            prevNextButtons: false,
            cellAlign: "left",
            contain: true,
            pageDots: false,
            wrapAround: false,
            selectedAttraction: 0.2,
            friction: 0.6,
            draggable: false,
            accessibility: false,
            on: {
              ready: () => this.sliderAccessibility(),
              change: () => this.sliderAccessibility()
            }
          });
        }
      }

      sliderAccessibility() {
        const interactiveElements = this.slideshowText.querySelectorAll(`${SELECTOR_SLIDE} a, ${SELECTOR_SLIDE} button`);
        
        if (interactiveElements.length) {
          interactiveElements.forEach((element) => {
            const slide = element.closest(SELECTOR_SLIDE);
            
            if (slide) {
              const tabIndex = slide.classList.contains(CLASS_IS_SELECTED) ? 0 : -1;
              element.setAttribute("tabindex", tabIndex);
            }
          });
        }
      }

      initSlideshowNav() {
        if (this.slideshowNav) {
          if (this.logoSlides.length) {
            this.logoSlides.forEach((slide) => {
              slide.addEventListener("click", () => {
                const slideIndex = parseInt(slide.getAttribute(ATTR_DATA_SLIDE_INDEX));
                const isFlickityEnabled = this.slideshowNav.classList.contains(CLASS_FLICKITY_ENABLED);
                
                if (this.flkty) {
                  this.flkty.select(slideIndex);
                }
                
                if (isFlickityEnabled) {
                  this.flktyNav.select(slideIndex);
                  
                  if (!this.slideshowNav.classList.contains(CLASS_IS_SELECTED)) {
                    this.flktyNav.playPlayer();
                  }
                } else {
                  const selectedSlide = this.slideshowNav.querySelector(`.${CLASS_IS_SELECTED}`);
                  
                  if (selectedSlide) {
                    selectedSlide.classList.remove(CLASS_IS_SELECTED);
                  }
                  
                  slide.classList.add(CLASS_IS_SELECTED);
                }
              });
            });
          }
          
          this.setSlideshowNavState();
          document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize);
        }
      }

      setSlideshowNavState() {
        const isFlickityEnabled = this.slideshowNav.classList.contains(CLASS_FLICKITY_ENABLED);
        
        if (this.logoSlidesWidth > window.theme.getWindowWidth()) {
          if (!isFlickityEnabled) {
            this.slideshowNav.classList.add(CLASS_IS_INITIALIZED);
            
            const selectedSlide = this.slideshowNav.querySelector(`.${CLASS_IS_SELECTED}`);
            
            if (selectedSlide) {
              selectedSlide.classList.remove(CLASS_IS_SELECTED);
            }
            
            this.logoSlides[0].classList.add(CLASS_IS_SELECTED);
            
            if (!this.flktyNav) {
              this.flktyNav = new window.theme.Flickity(this.slideshowNav, {
                prevNextButtons: false,
                contain: false,
                pageDots: false,
                cellAlign: "left",
                wrapAround: false,
                watchCSS: true,
                selectedAttraction: 0.05,
                friction: 0.8
              });
              
              this.flktyNav.on("deactivate", () => {
                this.slideshowNav.querySelector(SELECTOR_SLIDE).classList.add(CLASS_IS_SELECTED);
                
                if (this.flkty) {
                  this.flkty.select(0);
                }
              });
              
              if (this.flkty) {
                this.flkty.select(0);
                this.flktyNav.on("change", (index) => this.flkty.select(index));
              }
            }
          }
        } else if (isFlickityEnabled) {
          this.slideshowNav.classList.remove(CLASS_IS_INITIALIZED);
        }
      }

      onBlockSelect(event) {
        if (!this.slideshowNav) return;
        
        const slide = this.slideshowNav.querySelector(`[${ATTR_DATA_SLIDE}="${event.detail.blockId}"]`);
        const slideIndex = parseInt(slide.getAttribute(ATTR_DATA_SLIDE_INDEX));
        
        if (this.slideshowNav.classList.contains(CLASS_FLICKITY_ENABLED)) {
          this.flktyNav.select(slideIndex);
          this.flktyNav.stopPlayer();
          this.slideshowNav.classList.add(CLASS_IS_SELECTED);
        } else {
          slide.dispatchEvent(new Event("click"));
        }
      }

      onBlockDeselect() {
        if (this.slideshowNav && this.slideshowNav.classList.contains(CLASS_FLICKITY_ENABLED)) {
          this.flktyNav.playPlayer();
          this.slideshowNav.classList.remove(CLASS_IS_SELECTED);
        }
      }

      bindEvents() {
        this.addEventListener("theme:slider-logos:select", (event) => this.onBlockSelect(event.detail.evt));
        this.addEventListener("theme:slider-logos:deselect", () => this.onBlockDeselect());
      }

      disconnectedCallback() {
        document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize);
      }
    });
  }
})();
